import styled from 'styled-components';

export const Container = styled.div`
    /* border: 1px solid green; */
    position: static;
    z-index: 3;
    width: 100%;
    min-height: 250px;
`;
